import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";

import { BaseService } from "./base.service";

@Injectable()
export class ProfileService extends BaseService {
  constructor(protected http: Http, private router: Router) {
    super(http);
  }

  async getName(): Promise<string> {
    return this.get("profile/name");
  }

  async updateName(name: string) {
    return this.post("profile/name", { name: name });
  }

  async updatePassword(password: string) {
    return this.post("profile/password", { password: password });
  }

  async checkPassword(password: string) {
    return this.post("profile/checkPassword", { password: password });
  }

  async lookupUsername(userId: number): Promise<string> {
    return this.get("user/name/" + userId);
  }

  async getVersion(): Promise<string> {
    return this.get("version");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile.service.ts